import { Grid, Dropdown } from 'semantic-ui-react';

const { Row, Column } = Grid;

Dropdown.defaultProps!.icon = 'angle down';

export * from 'semantic-ui-react';
export { Row, Column };
